export default function ResultPanel({ furnitureList, collisionResult, ignoredCollisions }) {
    const totalFurniture = furnitureList.length

    // 無視されていない干渉のみをカウント
    const furnitureWithIssues = new Set([
        ...collisionResult.outOfBounds,
        ...Array.from(collisionResult.collisions.keys()).filter((id) => {
            const collidingWith = collisionResult.collisions.get(id)
            // この家具の干渉のうち、無視されていないものがあるかチェック
            return Array.from(collidingWith).some(otherId => {
                const key = [id, otherId].sort().join(':')
                return !ignoredCollisions.has(key)
            })
        }),
    ])
    const issueCount = furnitureWithIssues.size
    const isAllClear = totalFurniture > 0 && issueCount === 0

    return (
        <div className={`
      glass-effect rounded-2xl p-4 border-2 transition-all duration-300
      ${isAllClear
                ? 'border-green-500/50 bg-green-500/10'
                : issueCount > 0
                    ? 'border-red-500/50 bg-red-500/10'
                    : 'border-white/20'
            }
    `}>
            {/* 判定結果 */}
            <div className="flex items-center justify-center gap-4">
                <span className="text-4xl">
                    {isAllClear ? '✅' : issueCount > 0 ? '⚠️' : '📦'}
                </span>
                <div>
                    <h2 className="text-xl font-bold text-white text-center">
                        {isAllClear
                            ? '干渉なし！'
                            : issueCount > 0
                                ? '干渉あり'
                                : '家具を配置してください'
                        }
                    </h2>
                    {totalFurniture > 0 && (
                        <p className="text-xs text-gray-400">
                            {issueCount > 0
                                ? `${issueCount}個の家具に問題があります`
                                : 'すべての家具が正しく配置されています'
                            }
                        </p>
                    )}
                </div>
            </div>

            {/* 統計情報 - 常に表示してサイズを固定 */}
            <div className="mt-4 pt-4 border-t border-white/10 grid grid-cols-2 gap-4">
                <div className="text-center">
                    <div className="text-xl font-bold text-primary-400">{totalFurniture}</div>
                    <div className="text-xs text-gray-400 mt-1">総家具数</div>
                </div>
                <div className="text-center">
                    <div className={`text-xl font-bold ${issueCount > 0 ? 'text-red-400' : 'text-green-400'}`}>
                        {issueCount}
                    </div>
                    <div className="text-xs text-gray-400 mt-1">問題のある家具</div>
                </div>
            </div>
        </div>
    )
}
